import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ProductCardModule } from '@epicuro-next/ataraxia/product-card';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicLogicalOperationsModule } from '@epicuro-next/platform/dynamic-logical-operations';

import { DynamicElementsProductCardComponent } from './component/dynamic-elements-product-card.component';

@NgModule({
  imports: [
    CommonModule,
    DynamicLogicalOperationsModule,
    IconsModule,
    ProductCardModule,
  ],
  declarations: [DynamicElementsProductCardComponent],
  exports: [DynamicElementsProductCardComponent],
})
export class DynamicElementsProductCardModule {}

DontTreeShake(DynamicElementsProductCardComponent);
